import React from 'react';
import { scrollTo } from '../../utils/scrollTo';

function WhatWeDo() {
  return (
    <section className="section-padding bg-light">
      <div className="container">
        <h2 className="section-title reveal">What We Do</h2>
        <p className="description-text reveal">
          From strategy to execution, we enable healthcare brands to connect,
          communicate, and create an impact.
        </p>
        <button
          className="btn-main reveal"
          style={{ marginTop: '30px' }}
          onClick={() => scrollTo('contact')}
        >
          Talk to Our Team
        </button>
      </div>
    </section>
  );
}

export default WhatWeDo;
